<div class="unauthorized_wrappar" id="vi_unauthorized_wrappar">
  <div class="img-wrappar"><img src="../../assets/unauthorized.svg" /></div>
  <h3 class="no-access">No Access</h3>
  <p class="message-1">Sorry, you do not have access to this application,</p>
  <p class="message-2">Please contact with your administration.</p>
</div>
